var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.$isFlag ? "faceH5" : "faceWeb" },
    [
      _c("header-item", {
        attrs: {
          "title-array": _vm.titleArray,
          "title-mb": _vm.titleArray[0],
          "left-arrow": false
        }
      }),
      _vm._m(0)
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "faceResult" }, [
      _c("p", [
        _vm._v("请返回电脑端"),
        _c("br"),
        _vm._v("点击【认证已完成】查看人脸识别结果")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }